import React from 'react';
import { Card, Box, Avatar, Typography } from '@mui/material';

const formatMonthYear = (isoString) => {
  const date = new Date(isoString);
  return date.toLocaleDateString('en-US', { month: 'short', year: 'numeric' });
};

export default function UserSubmissionsSidebar({ username, count, firstDate }) {
  if (!username) return null;

  return (
    <Card variant="outlined" sx={{ p: 2 }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
        <Avatar sx={{ width: 64, height: 64 }}>{username[0]}</Avatar>
        <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
          {username}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {count} submissions
        </Typography>
        {firstDate && (
          <Typography variant="caption" color="text.secondary">
            Contributed since {formatMonthYear(firstDate)}
          </Typography>
        )}
      </Box>
    </Card>
  );
}
